/* Pond Haven mobile footer: turn the link columns into tap-to-expand accordions
   on mobile only (<=600px). Progressive enhancement over Booster's native
   footer, so all links stay editable in the theme editor and desktop is
   untouched. Collapsed by default; the contact column is never collapsed. */
(function () {
  var MQ = '(max-width: 600px)';
  var mql = window.matchMedia(MQ);
  var built = false;

  function isLinkCol(block) {
    // a footer block that contains a .footer__links list with a title
    var links = block.querySelector('.footer__links');
    if (!links) return null;
    var title = links.querySelector('.footer__title');
    return title ? { links: links, title: title } : null;
  }

  function build() {
    if (built) return;
    var foot = document.querySelector('#shopify-section-footer .footer');
    if (!foot) return;
    var blocks = foot.querySelectorAll('.footer__block');
    Array.prototype.forEach.call(blocks, function (b) {
      var col = isLinkCol(b);
      if (!col) return;
      b.classList.add('ph-foot-acc');
      col.title.classList.add('ph-foot-acc__head');
      col.title.setAttribute('role', 'button');
      col.title.setAttribute('tabindex', '0');
      col.title.setAttribute('aria-expanded', 'false');
      function toggle() {
        var open = b.classList.toggle('is-open');
        col.title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      col.title.addEventListener('click', function (e) {
        if (!mql.matches) return; // desktop: inert
        e.preventDefault();
        toggle();
      });
      col.title.addEventListener('keydown', function (e) {
        if (!mql.matches) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
    built = true;
  }

  function run() { if (mql.matches) build(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  if (mql.addEventListener) mql.addEventListener('change', run);
  else if (mql.addListener) mql.addListener(run);
})();
